import { z } from 'zod';
/** RFC 6901 JSON pointer, with the empty string addressing the whole document. */
export const FlowTestJsonPointerSchema = z.string().regex(/^(?:\/(?:[^~/]|~[01])*)*$/, {
    message: 'Must be an RFC 6901 JSON pointer, for example "/patient/firstName"',
});
export const FLOW_TEST_WHOLE_DOCUMENT_POINTER = '';
//# sourceMappingURL=jsonPointer.js.map